// identity-browser.js
// Browser-only wrapper: encrypted IndexedDB persistence for the
// identity core. Same pattern as identity.js (Node's filesystem
// wrapper) — the actual identity logic (key generation, fingerprint
// formatting) lives in identity-core.js and is never duplicated between
// platforms. The encryption itself is a separate transparent layer
// (see encrypted-identity-storage-browser.js) — identity-core.js has no
// idea it's happening, the same way it has no idea whether it's talking
// to a file or IndexedDB.

import { loadOrCreateIdentityFromStorage, fingerprintOf, importPublicKey, exportPublicKey } from '../identity-core.js'
import { IndexedDbStorage } from './storage-browser.js'
import { EncryptedIdentityStorage } from './encrypted-identity-storage-browser.js'

/**
 * Load this browser's identity from IndexedDB, or generate + persist a
 * new one. Unlike identity.js's Node version, there's no path argument —
 * a browser only has one identity per origin, stored under a fixed key.
 *
 * The identity's private key is encrypted at rest — PRF (WebAuthn,
 * hardware-backed) preferred when available, passphrase as fallback.
 * `ui` supplies the actual prompts; see EncryptedIdentityStorage's own
 * doc comment for the exact callback shapes required.
 * @param {object} ui
 */
export async function loadOrCreateIdentity (ui) {
  const storage = new EncryptedIdentityStorage(new IndexedDbStorage('identity'), ui)
  return loadOrCreateIdentityFromStorage(storage)
}

export { fingerprintOf, importPublicKey, exportPublicKey }
